import React, { useMemo } from 'react';
import whatsApp from './whatsApp.png';
import { displayCurrentYear } from '../utility';
import { useData, useTexts } from '../data';
import tracker from '../analytics/tracker';

const WhatsAppLink = ({ sandha = [], donors = [] }) => {
  const { time } = useData();
  const TEXTS = useTexts();

  const donorInfo = useMemo(() => {
    if (sandha.length > 0) {
      const donorLink =
        sandha.length > 1 &&
        (sandha[0]?.phone !== '' || sandha[0]?.phone !== null)
          ? sandha[0]?.phone
          : sandha[0]?.donorId;
      return {
        link: `https://kondarangihills.com/app/d/${donorLink}`,
        name: sandha[0]?.donorNameTamil,
        donorId: sandha[0]?.donorId,
        pincode: sandha[0]?.pincode,
        phone: sandha[0]?.phone == null ? TEXTS.DASH : sandha[0]?.phone,
        fullAddress: sandha[0]?.fullAddress,
        pageNumber: sandha[0]?.pageNumber,
        isPostalSent: sandha[0]?.isPostalSent,
      };
    } else if (donors.length > 0) {
      const donorLink =
        donors.length > 1 &&
        (donors[0]?.phone !== '' || donors[0]?.phone !== null)
          ? donors[0]?.phone
          : donors[0]?.donorId;
      return {
        link: `https://kondarangihills.com/app/d/${donorLink}`,
        name: donors[0]?.donorNameTamil,
        donorId: donors[0]?.donorId,
        pincode: donors[0]?.pincode,
        phone: donors[0]?.phone == null ? TEXTS.DASH : donors[0]?.phone,
        fullAddress: donors[0]?.fullAddress,
        pageNumber: donors[0]?.pageNumber,
        isPostalSent: donors[0]?.isPostalSent,
      };
    }
    return {
      link: '',
      name: '',
      pincode: '',
      donorId: '',
      phone: '',
      fullAddress: '',
      pageNumber: '',
      isPostalSent: false,
    };
  }, [sandha, donors, TEXTS]);

  const {
    link,
    name,
    donorId,
    pincode,
    phone,
    fullAddress,
    pageNumber,
    isPostalSent,
  } = donorInfo;

  if (!link) return null;

  return (
    <div className="text-center" data-component="WhatsAppLink">
      {time?.currentStatus !== 5 ? (
        <a
          className="btn btn-primary whatsapp-btn w-100"
          href={`https://wa.me/?text=1.%20*${TEXTS.YEAR_LABEL}*%20${displayCurrentYear(time)}%0A2.%20*${TEXTS.DONOR_ID_LABEL}*%20${donorId}%0A3.%20*${TEXTS.BOOK_FORMAT_LABEL}*%20${encodeURIComponent(name)},%20${pincode}%0A4.%20*${TEXTS.POSTAL_ADDRESS_LABEL}*%20${encodeURIComponent(fullAddress)}%0A5.%20*${TEXTS.PHONE_LABEL}*%20${phone}%0A6.%20*${TEXTS.MORE_DETAILS_LABEL}*%20_${link}_%0A`}
          target="_blank"
          rel="noreferrer"
          onClick={() => tracker.whatsappShareDonor(donorId)}
        >
          <img
            src={whatsApp}
            className="img-fluid me-2"
            alt={TEXTS.WHATSAPP_ALT}
          />
          {TEXTS.SHARE_ON_WHATSAPP}
        </a>
      ) : (
        <a
          className="btn btn-primary whatsapp-btn w-100"
          href={`https://wa.me/?text=1.%20*${TEXTS.YEAR_LABEL}*%20${displayCurrentYear(time)}%0A2.%20*${TEXTS.DONOR_ID_LABEL}*%20${donorId}%0A3.%20*${TEXTS.BOOK_FORMAT_LABEL}*%20${encodeURIComponent(name)},%20${pincode}%0A4.%20*${TEXTS.POSTAL_ADDRESS_LABEL}*%20${encodeURIComponent(fullAddress)}%0A5.%20*${TEXTS.PHONE_LABEL}*%20${phone}%0A6.%20*${TEXTS.PAGE_NUMBER_LABEL}*%20${pageNumber}%0A7.%20*${TEXTS.POSTAL_STATUS_LABEL}*%20${isPostalSent ? TEXTS.POSTAL_SENT_STATUS : TEXTS.POSTAL_NOT_SENT_STATUS}%0A8.%20*${TEXTS.MORE_DETAILS_LABEL}*%20_${link}_%0A`}
          target="_blank"
          rel="noreferrer"
          onClick={() => tracker.whatsappShareDonor(donorId)}
        >
          <img
            src={whatsApp}
            className="img-fluid me-2"
            alt={TEXTS.WHATSAPP_ALT}
          />
          {TEXTS.SHARE_ON_WHATSAPP}
        </a>
      )}
    </div>
  );
};

export default WhatsAppLink;
